<template>
  <GreyBarWithTitleAndValue
      is-with-borders
      title = "Points of Interest"
      :value = "$numberManagement.numberWithComma(itemData)"
  />
</template>

<script>

import GreyBarWithTitleAndValue from '../../../microcomponents/GreyBarWithTitleAndValue.vue';

export default {
  name: 'GrayBarPoisNumber',
  components: {
    GreyBarWithTitleAndValue,
  },

  props: {
    itemData: {
      type: [Number, String],
      default: null,
    },
  },
};
</script>
